import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const LandingHeaderComponent = () => {
  const history = useHistory()
  const location = useLocation()

  const onLogin = () => {
    history.push('/login')
  }
  const onSignup = () => {
    history.push('/signup')
  }

  return (
		<div className='landing-header-component'>
      <div className="header-menu">
        <div className="menu-right">
          {
            location.pathname.includes('login') ? (
              <button type="button" onClick={onSignup}>Sign Up</button>
            ) : (
              <button type="button" onClick={onLogin}>Sign In</button>
            )
          }
        </div>
      </div>
		</div>
  )
}

export default LandingHeaderComponent
